<!-- 报价-周期性报价 -->
<template>
  <div id="orderlist" style="width: 100%; height: 100%">
    <!-- <el-row>
      <h2>周期性报价</h2>
    </el-row> -->
    <el-row>
      <el-col :span="6">
        <el-button size="medium" @click="newPrice" style="margin-bottom: 10px">新增</el-button>
        <el-button size="medium" @click="lookPrice" style="margin-bottom: 10px; margin-left: 20px">查看报价</el-button>
        <el-button size="medium" type="primary" plain @click="openExport" style="margin-bottom: 10px; margin-left: 20px">导出价格</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-tabs v-model="activeName" @tab-click="setSupStatus">
        <!-- 团餐客户选项卡 -->
        <el-tab-pane name="tcCustomer">
          <span slot="label">团餐客户</span>
          <el-col :span="24">
            <el-table :data="tableData" border stripe style="width: 100%">
              <el-table-column type="index" label="序号" width="50"></el-table-column>
              <el-table-column prop="AB_NAME" label="公司"></el-table-column>
              <el-table-column prop="NEXT_START_DATE" label="生效时间"></el-table-column>
              <el-table-column prop="NEXT_END_DATE" label="失效日期"></el-table-column>
              <el-table-column prop="CHANGE_NUM" label="价格变化个数"></el-table-column>
              <el-table-column prop="STATUS" label="状态"></el-table-column>
              <el-table-column fixed="right" label="操作" width="150">
                <template slot-scope="scope">
                  <i class="el-icon-edit-outline" style="color: #409eff"></i>
                  <el-button type="text" size="small" @click="add(scope.row)">{{
                  showLable(scope.row)
                  }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="24" style="text-align: right">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
              layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
          </el-col>
        </el-tab-pane>
        <!-- 供应商客户选项卡 -->
        <el-tab-pane>
          <span slot="label" name="supplierCustomer">供应商客户</span>
          <el-col :span="24">
            <el-table :data="tableData" border stripe style="width: 100%">
              <el-table-column type="index" label="序号" width="50"></el-table-column>
              <el-table-column prop="AB_NAME" label="公司"></el-table-column>
              <el-table-column prop="NEXT_START_DATE" label="生效时间"></el-table-column>
              <el-table-column prop="NEXT_END_DATE" label="失效日期"></el-table-column>
              <el-table-column prop="CHANGE_NUM" label="价格变化个数"></el-table-column>
              <el-table-column prop="STATUS" label="状态"></el-table-column>
              <el-table-column fixed="right" label="操作" width="150">
                <template slot-scope="scope">
                  <i class="el-icon-edit-outline" style="color: #409eff"></i>
                  <el-button type="text" size="small" @click="add(scope.row)">{{
                  showLable(scope.row)
                  }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="24" style="text-align: right">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
              layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
          </el-col>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <!-- 导出选择公司模态框 -->
    <el-dialog title="请选择公司" center :visible.sync="exportFormVisible" width="600px" @close="close('exportForm')">
      <el-form :model="exportForm" ref="exportForm" style="margin-top: 0" size="small" :rules="rules">
        <el-form-item :label-width="formLabelWidth" prop="company">
          <label slot="label">公司名称：</label>
          <el-select filterable v-model="exportForm.company" placeholder="请选择公司" style="width: 100%" @change="getLable">
            <el-option v-for="item in companyList" :key="item.value" :label="item.AB_NAME" :value="item.ID">
              <span style="float: left; width: 50px; text-align: center">{{
              item.AB_NAME
              }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close('exportForm')">取 消</el-button>
        <el-button size="small" @click="submitExport('exportForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 新增选择公司模态框 -->
    <el-dialog title="请选择报价公司" center :visible.sync="addFormVisible" width="600px" @close="close('addForm')">
      <el-form :model="addForm" ref="addForm" :rules="rules" style="margin-top: 0">
        <el-form-item label="负责人：" :label-width="formLabelWidth" prop="company">
          <label slot="label">公司名称：</label>
          <el-select filterable v-model="addForm.company" placeholder="请选择公司" style="width: 100%" @change="getLable">
            <el-option v-for="item in companyList" :key="item.value" :label="item.AB_NAME" :value="item.ID">
              <span style="float: left; width: 50px; text-align: center">{{
              item.AB_NAME
              }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close('addForm')">取 消</el-button>
        <el-button @click="submitAdd('addForm')" v-if="this.addForm.company === ''" disabled>确 定</el-button>
        <el-button @click="submitAdd('addForm')" v-else>确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="请选择报价公司" center :visible.sync="queryFormVisible" width="600px" @click="close('queryForm')">
      <el-form :model="queryForm" ref="queryForm" :rules="rules" style="margin-top: 0">
        <el-form-item label="负责人：" :label-width="formLabelWidth" prop="company">
          <label slot="label">公司名称：</label>
          <el-select filterable v-model="queryForm.company" placeholder="请选择公司" style="width: 100%" @change="getLable">
            <el-option v-for="item in companyList" :key="item.value" :label="item.AB_NAME" :value="item.ID">
              <span style="float: left; width: 50px; text-align: center">{{
              item.AB_NAME
              }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close('queryForm')">取 消</el-button>
        <el-button @click="submitQuery('addForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { queryQuote, exportQuote, getCompanyList } from 'api/quote';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      // loading: false,
      rules: {
        company: [
          { required: true, message: '请选择公司', trigger: 'blur' },
        ],
      },
      queryFormVisible: false,
      queryForm: {},
      myWeek: '',
      addFormVisible: false,
      formLabelWidth: '100px',
      tableData: [],
      currentPage: 1,
      totalCount: 0,
      pageSize: 20,
      addForm: {
        company: '',
        AB_NAME: '',
      },
      exportForm: {},
      exportFormVisible: false,
      companyList: [],
      customerType: 0,
      activeName: 'tcCustomer',
    };
  },
  methods: {
    submitQuery() {
      if (!this.queryForm.company) {
        this.$message.show({ text: '请选择公司', type: 'warning' });
        return false;
      }
      sessionStorage.setItem('view_ID', this.queryForm.company);
      sessionStorage.setItem('customerType', this.customerType);
      sessionStorage.setItem('prevUrl', '/quote');
      this.$router.push({ name: 'viewPrice' });
    },
    showLable(row) {
      switch (row.STATUS) {
        case '已报价':
          return '报价';
        default:
          return '查看';
      }
    },
    newPrice() {
      this.addFormVisible = true;
      this.queryTitle();
    },
    queryTitle() {
      const params = {
        CUSTOMER_TYPE: this.customerType,
      };
      getCompanyList(params).then((res) => {
        this.companyList = res.length > 0 ? res[0].company : [];
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    submitAdd(formName) {
      if (Number(this.addForm.company) == 454 || Number(this.addForm.company == 723)) {
        this.$message.show({ text: '该公司不允许进行报价', type: 'warning' });
        return false;
      }
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              const params = {
                SERVICE_ID: '10040',
                OTYPE: 8,
                USER_ID: sessionStorage.getItem('userId'),
                SESSION: sessionStorage.getItem('session'),
                CUSTOMER_ID: this.addForm.company,
                CUSTOMER_TYPE: this.customerType,
              };
              http.post(params).then((result) => {
                sessionStorage.setItem('customerId', this.addForm.company);
                sessionStorage.setItem('customerName', this.addForm.AB_NAME);
                sessionStorage.setItem('customerType', this.customerType);
                document.body.style.cursor = 'default';
                this.$router.push({ name: 'SubmitPrice' });
              }).catch((error) => {
                this.$message.show({ text: error, type: 'error' });
                document.body.style.cursor = 'default';
              });
            } else {
              document.body.style.cursor = 'default';
              return false;
            }
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    queryGetTime() {
      const mydate = new Date();
      this.myWeek = mydate.getDay();// 获取存储当前日期
    },
    lookPrice() {
      this.queryTitle();
      this.queryFormVisible = true;
      // this.$router.push({name:'viewPrice'})
    },
    // 拉取数据
    queryQuoteList() {
      const params = {
        CUSTOMER_TYPE: this.customerType,
        PAGEINDEX: this.currentPage - 1,
        PAGESIZE: this.pageSize,
      };
      queryQuote(params)
        .then((result) => {
          if (result[0].OP_ROLE.length !== 0) {
            this.tableData = result[0].OP_ROLE;
            this.totalCount = result[0].TOTAL_COUNT;
            // ------------------tableData你的数据源
            this.tableData.forEach((element) => {
              switch (element.STATUS) {
                case 0:
                  element.STATUS = '未报价';
                  break;
                case 1:
                  element.STATUS = '未审核';
                  break;
                case 2:
                  element.STATUS = '审核中';
                  break;
                case 3:
                  element.STATUS = '已审核';
                  break;
                default:
                  element.STATUS = '状态未翻译';
              }
            });
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    getLable(vId) {
      let obj = {};
      obj = this.companyList.find((item) => item.ID === vId);
      this.addForm.AB_NAME = obj.AB_NAME;
    },
    add(row) {
      sessionStorage.setItem('company', row.AB_NAME);
      sessionStorage.setItem('startTime', row.NEXT_START_DATE);
      sessionStorage.setItem('endTime', row.NEXT_END_DATE);
      sessionStorage.setItem('status', row.STATUS);
      sessionStorage.setItem('customerType', this.customerType);
      this.$router.push({ name: 'supplierProduct', params: { submitId: this.customerType === 0 ? row.TC_ID : row.GYS_ID } });
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.queryQuoteList();
    },
    // 关闭dialog并清空
    close(formName) {
      this.$refs[formName].resetFields();
      const modalName = `${formName}Visible`;
      this[`${modalName}`] = false;
      this.exportForm.company = '';
    },
    openExport() {
      this.exportFormVisible = true;
      this.queryTitle();
    },
    // -----------------------------------导出
    submitExport(formName) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              const params = {
                CUSTOMER_ID: Number(this.exportForm.company),
                CUSTOMER_TYPE: this.customerType,
              };
              // this.loading = true
              exportQuote(params)
                .then((result) => {
                  // this.loading = false
                  window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
                  this.exportFormVisible = false;
                  document.body.style.cursor = 'default';
                }).catch((error) => {
                  // this.loading = false
                  this.$message.show({ text: error, type: 'error' });
                  document.body.style.cursor = 'default';
                });
            } else {
              document.body.style.cursor = 'default';
              return false;
            }
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    // 判断订单状态，0为团餐客户，1为供应商客户
    setSupStatus(tab, event) {
      this.customerType = Number(tab.index);
      this.queryQuoteList();
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryQuoteList();
    this.queryGetTime();
    this.queryTitle();
    console.log(this.customerType);
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/priceManagement/periodicQuotation.vue